import ScrollManager from './ScrollManager'
import Hamburger from './Hamburger'
import SmoothScroll from './SmoothScroll'
import NavigationHover from './NavigationHover'
import Loading from './Loading'
import LogoScroll from './LogoScroll'
import IntersectionObserver from './IntersectionObserver'
import LanguageSwitcher from './LanguageSwitcher'

export default class {
  constructor() {

    new LogoScroll();

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    const domLanguage = document.querySelector('[data-js="language"]');
    if (domLanguage) new LanguageSwitcher(domLanguage);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    let hamburgerInstance = null;
    if (domHamburger) {
      hamburgerInstance = new Hamburger(domHamburger);
    }

    // SmoothScrollを初期化してHamburgerインスタンスを渡す
    setTimeout(() => {
      // console.log('Initializing SmoothScroll...');
      const smoothScroll = new SmoothScroll();
      if (hamburgerInstance) {
        smoothScroll.setHamburger(hamburgerInstance);
      }
    }, 100);

    // ナビゲーションホバーアニメーション（一時的にコメントアウト）
    const domNavigationHover = document.querySelectorAll('[data-js="hover"]');
    if (domNavigationHover) {
      [...domNavigationHover].forEach(el => {
        new NavigationHover(el);
      });
    }

    const domModalMovies = document.querySelector('[data-js="modal-movies"]');
    if (domModalMovies) new ModalMovies(domModalMovies);

    const domSmilesSlider = document.querySelector('[data-js="smiles-modal-slide"]');
    if (domSmilesSlider) new SmilesSlider(domSmilesSlider);  
    
    const domLoading = document.querySelector('[data-js="loading"]');
    
    const now = Date.now();
    const lastVisit = localStorage.getItem('loading_last_visit');
    const ONE_DAY = 24 * 60 * 60 * 1000;
    
    const shouldSkipLoading = lastVisit && (now - parseInt(lastVisit, 10) < ONE_DAY);
    
    if (!shouldSkipLoading) {
      new Loading(domLoading);
      localStorage.setItem('loading_last_visit', now.toString());
    } else {
      if (domLoading) {
        domLoading.remove();
      }
      const domLoadingHero = document.querySelector('[data-js="hero"]');
      if (domLoadingHero) {
        domLoadingHero.style.opacity = 1;
      }
      document.body.dataset.loaded = true;
      document.body.removeAttribute('data-is-scrolldisable');

      const domIntersectionObserver = document.querySelectorAll('[data-io]');
      if (domIntersectionObserver) {
        new IntersectionObserver(domIntersectionObserver);
      }
    }
  }
}
